import React from "react";

const projects = [
  {
    title: "Central Mayorista Digital",
    description:
      "Plataforma para digitalizar la cadena de suministro, conectar comerciantes y clientes.",
    image:
      "https://i.postimg.cc/vZRFTfmN/centralmay9i.png", 
    link: "https://centralmayoristadigital.web.app/",
  },
  {
    title: "Club de Baloncesto Cúcuta Norte",
    description:
      "Página oficial del club deportivo, con noticias, galería de imágenes, y un sistema de contacto para inscripciones.",
    image:
      "https://i.postimg.cc/fy4pyhz5/clubdsf.png",
    link: "https://clubdebaloncestocucutanortedesantander.com/",
  },
  {
    title: "YEDA",
    description:
      "Plataforma startup para gestión de contactos, desarrollada con Angular y Firebase.",
    image:
      "https://i.postimg.cc/nhLk55q5/yeda.png",
    link: "https://yeda-fcaf0.web.app/",
  },
  {
    title: "Mar y Beauty",
    description:
      "Plataforma web app responsiva en React, vite tailwind, enfocada en soluciones digitales para emprendimientos.",
    image:
      "https://i.postimg.cc/fTymySPk/mar-y-bauuty.png", 
    link: "https://marymarbeauty-7f19d.web.app/",
  },
   {
    title: "EL CAMINANTE",
    description:
      "Plataforma web responsiva  en React, vite tailwind, enfocada en soluciones digitales para emprendimientos",
    image:
      "https://i.postimg.cc/JngDBPvG/elcaminate.png", 
    link: "https://690403167154a17d071538d1--euphonious-stardust-6b80fe.netlify.app/",
  },
  {
    title: "Seguimiento de tracking",
    description:
      "Plataforma web responsiva  en React, vite tailwind, enfocada en soluciones digitales para emprendimientos",
    image:
      "https://i.postimg.cc/MZV1gfLC/traking.png", 
    link: "https://just-international-logistics.web.app/",
  },
];

const Projects = () => {
  return (
    <section id="projects" aria-label="Proyectos" className="py-10">
      <h2 className="text-2xl font-poppins mb-6">Proyectos Destacados</h2>
      <div className="grid md:grid-cols-2 gap-6">
        {projects.map((project, index) => (
          <a
            key={index}
            href={project.link}
            target="_blank"
            rel="noopener noreferrer"
            className="p-4 rounded-lg border hover:scale-105 transition shadow-lg bg-white"
          >
            <img
              src={project.image}
              alt={project.title}
              className="rounded-md mb-4 w-full h-48 object-cover"
            />
            <h4 className="font-semibold">{project.title}</h4>
            <p className="mt-2 text-sm text-gray-600">{project.description}</p>
          </a>
        ))}
      </div>
    </section>
  );
};

export default Projects;
